import { release } from './release';
import { releaseAction } from './release-action';

export const contentTypes = {
  release,
  'release-action': releaseAction,
};
